import { css } from "@emotion/css"

import Skeleton from "@p-ban/common/src/components/Skeleton"
import Anchor from "@p-ban/common/src/components/html/Anchor"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import useUserQuery from "../../../../api/user/useUserQuery"
import SideBarBox from "../components/SideBarBox"
import SideBarLink from "../components/SideBarLink"
import VolumeDiscount from "./VolumeDiscount"

const UserInfo = () => {
  const userInfo = useUserQuery()

  return (
    <SideBarBox>
      <div className={styles.userInfo.container}>
        {userInfo && (
          <>
            {userInfo.companyName && <div className={styles.userInfo.company}>{userInfo.companyName}</div>}
            <Spacer size={9} />
            <div className={styles.userInfo.name}>{userInfo.userName} 様</div>
            <Spacer size={9} />
            <div className={styles.userInfo.id}>ユーザーID {userInfo.id}</div>
          </>
        )}
        {!userInfo && (
          <>
            <Skeleton width={160} height={14} />
            <Spacer size={9} />
            <Skeleton width={160} height={24} />
            <Spacer size={9} />
            <Skeleton width={160} height={14} />
          </>
        )}
      </div>
      {(!userInfo || userInfo.hasVolumeDiscountInfo) && (
        <>
          <Spacer size={15} />
          <VolumeDiscount />
        </>
      )}
      <SideBarLinkButton href="/kiban/com/csComTop.do#work_list">案件一覧はこちら</SideBarLinkButton>
      <SideBarLinkButton href="/kiban/com/csComTop.do?filter=Completed#work_list">完了一覧はこちら</SideBarLinkButton>
      <SideBarLink href="/kiban/csComLogout.do">ログアウト</SideBarLink>
    </SideBarBox>
  )
}

export default UserInfo

const SideBarLinkButton = ({ href, children }: { href: string; children: string }) => {
  return (
    <Anchor href={href} className={styles.linkButton} hoverClassName={styles.linkButtonHover}>
      {children}
    </Anchor>
  )
}

const styles = {
  userInfo: {
    container: css`
      padding: 0px 6px;
      line-height: 1.2;
      color: #666666;
    `,
    company: css`
      font-size: 12px;
      font-weight: bold;
    `,
    name: css`
      font-size: 20px;
      font-weight: bold;
    `,
    id: css`
      font-size: 12px;
    `,
  },
  linkButton: css`
    display: block;
    width: 160px;
    padding-top: 13px;
    padding-bottom: 10px;
    margin: 15px 6px;
    font-size: 15px;
    line-height: 1;
    color: #fff;
    text-align: center;
    background: #3f83ba;
    border-radius: 3px;
  `,
  linkButtonHover: css`
    opacity: 0.7;
  `,
}
